<div [ngClass]="itemContentInnerClass"
     [style.width.px]="menuWidthChange$ | async">
  <ng-content />
</div>

